import axios from 'axios'
import router from '@/router'

const authModule = {
  namespaced: true,
  state: {
    isAuthenticated: false,
    authAttempted: false
  },
  mutations: {
    SET_AUTHENTICATED (state) {
      state.isAuthenticated = true
    },
    SET_AUTH_ATTEMPTED (state) {
      state.authAttempted = true
    }
  },
  actions: {
    SET_ACCESS_TOKEN_EXPIRY ({ commit }, value) {
      const expiry = new Date()
      expiry.setSeconds(expiry.getSeconds() + value.expires_in)
      sessionStorage.setItem('access_token_expiry', expiry.getTime())
    },
    SET_ACCESS_TOKEN ({ commit }, value) {
      sessionStorage.setItem('access_token', JSON.stringify(value))
    },
    REMOVE_ACCESS_TOKEN () {
      sessionStorage.removeItem('access_token')
      sessionStorage.removeItem('access_token_expiry')
    },
    SET_AUTHENTICATION_VALUES ({ commit, dispatch }, accessToken) {
      commit('SET_AUTHENTICATED')
      commit('SET_AUTH_ATTEMPTED')
      axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
    },
    AUTHENTICATE ({ commit, dispatch }, key) {
      return axios({
        method: 'post',
        baseURL: process.env.VUE_APP_API_URL,
        url: '/login/sign',
        data: {
          key
        }
      }).then((response) => {
        dispatch('SET_AUTHENTICATION_VALUES', response.data.data.access_token)
        dispatch('SET_ACCESS_TOKEN', response.data.data)
        dispatch('SET_ACCESS_TOKEN_EXPIRY', response.data.data)
      }).catch((error) => {
        sessionStorage.removeItem('access_token')
        commit('SET_AUTH_ATTEMPTED')
        const errorResponse = {
          errorMessage: (error.response && error.response.data.message) || error.message,
          errorCode: (error.response && error.response.status) || 0
        }

        router.push({ name: 'PageError', params: errorResponse })
      })
    },
    AUTHENTICATE_PREVIEW ({ commit }, key) {
      return axios({
        method: 'post',
        baseURL: process.env.VUE_APP_API_URL,
        url: '/login/preview',
        data: {
          key
        }
      }).then((response) => {
        const { data: { data: { access_token: token } } } = response
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
        commit('SET_AUTHENTICATED')
        commit('SET_AUTH_ATTEMPTED')
      }).catch((error) => {
        commit('SET_AUTH_ATTEMPTED')
        const errorResponse = {
          errorMessage: (error.response && error.response.data.message) || error.message,
          errorCode: (error.response && error.response.status) || 0
        }

        router.push({ name: 'PageError', params: errorResponse })
      })
    }
  },
  getters: {
    isAuthenticated: state => state.isAuthenticated,
    authAttempted: state => state.authAttempted
  }
}

export default authModule
